import { loginToUrl, getQueryValue } from '@/utils'
export default {
    props: {
        vuexModeuleName: {
            type: String,
            default: ''
        }
    },
    computed: {
        loginData() {
            return this.$store.state[this.vuexModeuleName].loginData
        }
    },
    methods: {
        clearToken(name = 'n-token', value = '') {
            let Days = 30
            let exp = new Date()
            exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000)
            let domain = '.nucarf.tech'
            if (location.hostname.includes('.cn')) {
                domain = '.nucarf.cn'
            }
            if (location.hostname.includes('.com')) {
                domain = '.nucarf.com'
            }
            document.cookie =
                name +
                '=' +
                escape(value) +
                ';expires=' +
                exp.toGMTString() +
                `;path=/;domain=${domain}`
            setTimeout(() => {
                window.location.reload()
            }, 1000)
        },
        // 登录权限操作 逻辑
        authentication(info) {
            let companys = info.companys
            // 是否有未加入的企业 如果有 弹框加入
            let isHasCompany = companys.find(item => !item.hasJoined)

            let parasmUrl = getQueryValue('redirect')
            if (parasmUrl && parasmUrl !== 'authentication') {
                window.location.href = decodeURIComponent(parasmUrl)
                return
            }
            //  是否存在 redirect 存在跳到对应的页面
            if (
                window.location.search &&
                window.location.search.includes('redirect=')
            ) {
                window.location.href =
                    window.location.search.split('?')[1].indexOf('&') === -1
                        ? decodeURIComponent(
                              window.location.search.split('?')[1].split('=')[1]
                          )
                        : decodeURIComponent(
                              window.location.search
                                  .split('?')[1]
                                  .split('&')
                                  .filter(item => !item.indexOf('redirect'))[0]
                                  .split('=')[1]
                          )
            } else {
                // 首先判断是否设置过登录密码
                if (!info.hasPassword) {
                    this.$store.commit(
                        this.vuexModeuleName + '/updateStateData',
                        {
                            loginData: info,
                            isLoginWindow: false,
                            isPwd: true
                        }
                    )
                    // 如果设置过密码 并且有加未加入的企业 弹出企业加入框
                } else if (info.hasPassword && isHasCompany) {
                    this.$store.commit(
                        this.vuexModeuleName + '/updateStateData',
                        {
                            loginData: info,
                            isLoginWindow: false,
                            isCompany: true
                        }
                    )
                    // 如果有设置过密码 并且 企业列表有数据 并且都加入过 直接进入第一个企业
                } else if (
                    info.hasPassword &&
                    companys.length &&
                    !isHasCompany
                ) {
                    loginToUrl(companys[0].subDomain)
                } else if (info.hasPassword && companys.length === 0) {
                    this.clearToken()
                }
            }
        }
    }
}
